export const GET_ALL_LICENSES_BY_CLIENT = "GET_ALL_LICENSES_BY_CLIENT"
export const DOWNLOAD_LICENSE = "DOWNLOAD_LICENSE"
export const CREATE_LICENSE = "CREATE_LICENSE"
export const CLEAR_LICENSES = "CLEAR_LICENSES"
export const UPDATE_ARBIS_AI_LICENSE = "UPDATE_ARBIS_AI_LICENSE"